import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Empresa } from '../interfaces/empresa.interface';
import { firstValueFrom } from 'rxjs';
import { RegistroService } from 'src/app/registro.service';

@Injectable({
    providedIn: 'root',
})
export class EditEmpresaService {
    constructor(
        private http: HttpClient,
        private registroService: RegistroService
    ) {}
    private apiUrl: string = environment.apiSiriUrl;

    async getEmpresaActual(endPoint: string) {
        try {
            const url = `${this.apiUrl}${endPoint}/${this.registroService.empresaSelected}`;
            const response = firstValueFrom(await this.http.get<Empresa>(url));
            return response;
        } catch (error) {
            console.error('Error al obtener la empresa actual:', error);
            throw error;
        }
    }

    async getEmpresaActualAdministrador(endPoint: string) {
        try {
            const url = `${this.apiUrl}${endPoint}`;
            const response = firstValueFrom(await this.http.get<Empresa>(url));
            return response;
        } catch (error) {
            console.error('Error al obtener la empresa actual:', error);
            throw error;
        }
    }

    async putEmpresaActual(endPointId: string, empresa: Empresa) {
        try {
            const url = `${this.apiUrl}${endPointId}`;
            const empresaActualizada = await this.http
                .put<Empresa>(url, empresa)
                .toPromise();
            return empresaActualizada;
        } catch (error) {
            console.error('Error al actualizar la empresa:', error);
            throw error;
        }
    }
}
